import { ReactNode } from "react";
import { ButtonProps, Flex, useDisclosure } from "@chakra-ui/react";
import BaseEditButton from "components/Shared/EditButton";
import Panel, { PanelHeader, PanelHeading, PanelProps } from ".";

type EditButtonProps = ButtonProps & {
  isOpen?: boolean;
};

export function EditButton({ isOpen, ...rest }: EditButtonProps) {
  return (
    <BaseEditButton
      variant="ghost"
      mr={-2}
      color="gray.600"
      isEditing={isOpen}
      {...rest}
    />
  );
}

type RenderContentProps = {
  isEditing: boolean;
  onCloseEdit: () => void;
  onEdit: () => void;
  onToggleEdit: () => void;
};

type SimplePanelProps = PanelProps & {
  footer?: ReactNode;
  header?: ReactNode;
  headerRight?: ReactNode;
  heading?: ReactNode;
  renderContent: (props: RenderContentProps) => ReactNode;
};

export default function EditablePanel({
  children,
  footer,
  header,
  headerRight,
  heading,
  renderContent,
  ...rest
}: SimplePanelProps) {
  const { isOpen, onToggle, onClose, onOpen } = useDisclosure();
  return (
    <Panel {...rest}>
      {(header || heading) && (
        <PanelHeader>
          {heading && <PanelHeading>{heading}</PanelHeading>}

          {header}

          <Flex ml="auto" gap={2}>
            {headerRight}
            <EditButton onClick={onToggle} isOpen={isOpen} />
          </Flex>
        </PanelHeader>
      )}

      {renderContent({
        isEditing: isOpen,
        onEdit: onOpen,
        onCloseEdit: onClose,
        onToggleEdit: onToggle,
      })}
    </Panel>
  );
}
